<!-- Contenu des messages à droite -->
<div class="chat-content" *ngIf="chatWindow?.userData">

    <!-- Fenêtres de chat -->
    
        <div class="chat-window">
        <div class="chat-header">
            <div class="chatInfo">
                <img [src]="chatWindow.userData.profilePhotoUrl" 
                     alt="{{chatWindow.userData.publicName}}" 
                     class="profile-picture2 col-2" 
                     [routerLink]="['/postfeed/userprofile', chatWindow.userData.uid]">
                <div>
                    <div>{{chatWindow.userData.publicName}}</div>
                    <div><small style="color: gray;">({{chatWindow.userData.description}})</small></div>
                </div>
            </div>
            
            <button (click)="closeChatWindow()" class="close-button">
                <mat-icon>close</mat-icon>
            </button> <!-- Bouton pour fermer la fenêtre -->
        </div>
        <!--<div class="chat-messages">
            <div *ngFor="let message of messages">
              <span [ngClass]="{'my-message': message.senderId === currentUser.id}">
                {{message.text}}
              </span>
            </div>
          </div>-->

          <!--<div class="chat-messages" #messageContainer (scroll)="checkIfScrolledToBottom(chatWindow, messageContainer)">
            <div *ngFor="let message of chatWindow.messages; let i = index" class="chat-message">
              <span [ngClass]="{'sent': message.senderId === currentUserId, 'received': message.senderId !== currentUserId}">{{ message.text }}</span>
              
              <span [ngClass]="{'sentAt': message.senderId === currentUserId, 'receivedAt': message.senderId !== currentUserId}"><small >{{ message.timestamp | date:'shortTime' }}</small></span>
            </div>
          </div>-->

          <div class="chat-messages" #messageContainer (scroll)="checkIfScrolledToBottom(chatWindow, messageContainer)">
            <div *ngFor="let message of chatWindow.messages; let i = index" class="chat-message">
              <div [ngClass]="{'sent': message.senderId === currentUserId, 'received': message.senderId !== currentUserId}">
                <img *ngIf="message.imageUrl" [src]="message.imageUrl" alt="Comment image" class="comment-image"  >
                <div >{{ message.text }}</div>
                <div *ngIf="message.audioUrl">
                    <audio controls class="audio-player" #audioPlayer>
                        <source [src]="message.audioUrl" type="audio/mpeg"> 
                        Votre navigateur ne supporte pas l'élément audio.
                    </audio>
                </div>
              
                
                <small class="message-time">{{ getMessageFormattedDate(message.timestamp) }}</small>
  
              </div>
             
              
            </div>
          </div>
        <!--<div class="chat-input">
            <textarea #messageInput 
                class="message-input" 
                placeholder="Écrire un message..." 
                wrap="soft"
                rows="4"
                (keydown)="handleKeydown($event, chatWindow, messageContainer)" (input)="onInputChange()">
            </textarea>
            
            <button class="send-button" (click)="sendMessage(chatWindow)">
                <img src = "../../../assets/images/img/paper-plane2.png" class="envelope-icon">
                <i class="envelope-icon"></i>
              </button>
           
        </div>-->


        <div class="chat-input">
          <!-- Zone d'aperçu -->
 <div class="preview-container" *ngIf="chatWindow.audioBlobUrl || chatWindow.imageBlobUrl">
 <!-- Aperçu de l'audio -->
 <div class="audio-preview" *ngIf="chatWindow.audioBlobUrl">
 <audio controls [src]="chatWindow.audioBlobUrl"></audio>
 <button (click)="removeFile(chatWindow)" class="close-button2">x</button>
 </div>
 
 <!-- Aperçu de l'image -->
 <div class="image-preview " *ngIf="chatWindow.imageBlobUrl">
 <img [src]="chatWindow.imageBlobUrl" alt="Image preview" style="width: 60px; height: 50px;">
 <button (click)="removeFile(chatWindow)" class="close-button2">x</button>
 </div>
 </div>
 
 <!-- Vérifiez si l'enregistrement n'est pas en cours et qu'aucun fichier audio n'est sélectionné -->
 <ng-container *ngIf="!chatWindow.isRecording && !chatWindow.audioBlobUrl; else recordingTemplate">
 <textarea [(ngModel)]="chatWindow.newMessage" 
         class="message-input" 
         placeholder="Écrire un message..." 
         id="messageInput"
         wrap="soft"
         rows="4"
         (keydown)="handleKeydown($event, chatWindow)">
 </textarea>
 
 <!-- Bouton de sélection de fichier -->
 <button mat-button color="warn" class="file-selector-button mt-2" 
       [matMenuTriggerFor]="fileMenu" 
       [hidden]="chatWindow.isRecording || chatWindow.audioBlobUrl">
 <mat-icon>attach_file</mat-icon>
 </button>
 
 <!-- Bouton pour envoyer le message ou enregistrer un audio -->
 <button mat-icon-button class="centered-button" (click)="handleSend(chatWindow)">
 <ng-container *ngIf="chatWindow.newMessage && chatWindow.newMessage.trim() !== '' || chatWindow.audioBlobUrl; else micTemplate">
   
   
   <span style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
     <mat-icon>send</mat-icon>
   </span>
 </ng-container>
 <ng-template #micTemplate>
   
   <span style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
     <mat-icon (click)="startRecording(chatWindow)">mic</mat-icon>
   </span>
 </ng-template>
 </button>
 </ng-container>
         
         <!-- Template pour l'enregistrement vocal -->
         <ng-template #recordingTemplate style="max-width: 100%; display: flex; border: 1px solid red;">
           <div class="recording-indicator" [hidden]="!chatWindow.isRecording">
             <span style="min-width: 70%; margin-left: 35px; margin-right: 30px; color: red;">Enregistrement en cours...</span>
             
             <button mat-icon-button
                 (click)="stopRecording(chatWindow)"
                     style="color: rgb(255, 255, 255); background-color: rgb(44, 195, 246); margin-left: 3px; margin-bottom: 9px;" 
                     [ngClass]="{'recording': isRecording}" class="centered-button">
                    
                     <span style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
                       <mat-icon>stop</mat-icon>
                     </span>
             </button>
           </div>
           <button mat-icon-button class="centered-button" 
             (click)="handleSend(chatWindow, i)" 
             *ngIf="chatWindow.audioBlobUrl"
             style="color: rgb(255, 255, 255); background-color: rgb(44, 195, 246); margin-left: 3px; margin-bottom: 9px;" >
           <ng-container >
             
             
             <span style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
               <mat-icon>send</mat-icon>
             </span>
           </ng-container>
           
         </button>
         </ng-template>
         <div>
           <!-- Bouton pour envoyer le message ou enregistrer un audio -->
         
 
         
       
         <mat-menu #fileMenu="matMenu" xPosition="after" yPosition="above"> 
           <button mat-menu-item (click)="selectFile(chatWindow,'image')">Image</button>
           <button mat-menu-item (click)="selectFile(chatWindow,'audio')">Audio</button>
         </mat-menu>
         </div>
 
         
 
         
       </div>
        </div>

        
      <!--<div class="chat-input">
          <textarea [(ngModel)]="chatWindow.newMessage" 
              class="message-input" 
              placeholder="Écrire un message..." 
              id="messageInput"
              wrap="soft"
              rows="4"
              (keydown)="handleKeydown($event, chatWindow, messageContainer)">
          </textarea>
          
          <button class="send-button" (click)="sendMessage(chatWindow, i)">
              <img src = "../../../assets/images/img/paper-plane2.png" class="envelope-icon">
              <i class="envelope-icon"></i>
            </button>

      </div>-->

      
    
  </div>
